// ThankyouPage.tsx
import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GradientThankYou from '../../assets/images/GradientThankYou';
import { useTranslation } from 'react-i18next';

const ThankyouPage: React.FC = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    const handleConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        navigate('/invoiceForm');
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <Grid
            container
            component="form"
            noValidate
            autoComplete="off"
            direction="column"
            justifyContent="center"
            // alignItems="center"
            sx={{ flex: 1 }}
        >
            <Grid container direction="column" justifyContent="center" alignItems="center" sx={{
                marginTop: '1rem',
                position: 'relative'
            }}>
                <GradientThankYou size={'50%'} />
                <Box position="absolute" bottom={isMobile ? '-0.5rem' : '-1rem'} display="flex" justifyContent="center" width="100%">
                    <Typography variant={isMobile ? 'h4' : 'h1'} sx={{ color: 'var(--dark)', fontWeight: 'bold' }}>Thank You !</Typography>
                </Box>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ padding: isMobile ? '1rem' : '2rem' }}>
                <Typography variant='body1' sx={{ color: 'var(--dark)' }}>{t('general.thankyouMessage')}</Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ padding: isMobile ? '1rem' : '2rem' }}>
                <Button variant="contained" color="primary" onClick={handleGoHome}>
                    请点击以回到首页
                </Button>
            </Grid>
        </Grid>
    );
}

export default ThankyouPage;